// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let UTCDate = require("../reason/common/types/UTCDate.bs.js");
let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let TemporalPolyfill = require("temporal-polyfill");

function fromInt(prim) {
  return prim;
}

let PriceInput = {
  fromInt: fromInt
};

function fromInt$1(year) {
  if (year >= (new Date().getFullYear() - 200 | 0) && year <= (new Date().getFullYear() + 50 | 0)) {
    return {
      TAG: "Ok",
      _0: year
    };
  } else {
    return {
      TAG: "Error",
      _0: "InvalidYear"
    };
  }
}

function toInt(year) {
  return year;
}

let validate = fromInt$1;

function fromString(value) {
  let year = Stdlib_Int.fromString(value, undefined);
  if (year !== undefined) {
    return fromInt$1(year);
  } else {
    return {
      TAG: "Error",
      _0: "InvalidYear"
    };
  }
}

function toString(year) {
  return year.toString();
}

let Year = {
  fromInt: fromInt$1,
  fromString: fromString,
  validate: validate,
  toInt: toInt,
  toString: toString
};

function fromJsDate(prim) {
  return prim.toISOString();
}

let DateTime = {
  toUTC: UTCDate.fromString,
  fromJsDate: fromJsDate
};

let emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

function validate$1(v) {
  if (emailRegex.test(v)) {
    return {
      TAG: "Ok",
      _0: v
    };
  } else {
    return {
      TAG: "Error",
      _0: "InvalidEmailAddress"
    };
  }
}

function toString$1(v) {
  return v;
}

let EmailAddress = {
  validate: validate$1,
  toString: toString$1
};

let JSONObject = {};

function toWebapiUrl(t) {
  return new URL(t);
}

function toString$2(v) {
  return v;
}

function fromString$1(v) {
  let rawUrl = v.startsWith("http://") || v.startsWith("https://") ? v : "https://" + v;
  let urlRegex = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
  if (urlRegex.test(rawUrl)) {
    return {
      TAG: "Ok",
      _0: rawUrl
    };
  } else {
    return {
      TAG: "Error",
      _0: "InvalidURL"
    };
  }
}

let HTML = {};

function parse(prim) {
  return TemporalPolyfill.Temporal.PlainDateTime.from(prim);
}

function serialize(prim) {
  return prim.toString();
}

let PlainDateTime = {
  parse: parse,
  serialize: serialize
};

let CalendarDate;

let URL$1 = {
  toString: toString$2,
  toWebapiUrl: toWebapiUrl,
  fromString: fromString$1
};

exports.PriceInput = PriceInput;
exports.CalendarDate = CalendarDate;
exports.Year = Year;
exports.DateTime = DateTime;
exports.EmailAddress = EmailAddress;
exports.JSONObject = JSONObject;
exports.URL = URL$1;
exports.HTML = HTML;
exports.PlainDateTime = PlainDateTime;
/* UTCDate Not a pure module */
